import React, { useState, useEffect } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { DatePicker,message } from "antd";
import dayjs from "dayjs";
import { Country, State } from "country-state-city";
import { updatereceptionist } from "../../services/doctor/reception/reception";
import Select from "react-select";
import { Link, useParams, useNavigate,useLocation } from 'react-router-dom';
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useMessageApi } from "../../services/message api/MessageProvider";
import { updatePharmacist } from "../../services/doctor/pharmacies/pharmacies";

const EditPharmaciest = () => {

  const location = useLocation();
  const { receptionist } = location.state || {}; 
  console.log("receptionist", receptionist)
  const  id  = receptionist?.id;
  const navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  
  

  const [country, setCountry] = useState();
        const [statevalue, setStateValue] = useState();
      
        useEffect(() => {
          const states = State.getStatesOfCountry("IN"); 
          const formattedStates = states?.map((state) => ({
            label: state.name,
            value: state.name,
          }));
          const options = Country.getAllCountries()?.map((country) => ({
            label: country.name,
            value: country.name,
          }));
          setCountry(options);
          setStateValue(formattedStates);
        }, []); 
  

  

 const onChange = (date, dateString) => {
    setIsClicked(true);
    handleChange(date.toISOString().split("T")[0], "date_of_birth");
  };

  
  const loadFile = (event) => {
    // Handle file loading logic here
  };
  
  const [formData, setFormData] = useState({
    name: "",
    last_name: "",
    middle_name: "",
    mobile: "",
    email: "",
    password: "",
    gender: "",
    aadhaar_card_number: "",
    date_of_birth: "",
    address: "",
    city: "",
    country: "",
    state: "",
    pincode: ""
  });

  // Load existing data into form when component mounts
  useEffect(() => {
    if (receptionist) {
      setFormData({
  name: receptionist?.Name || "",
  last_name: receptionist?.lastname || "",
  middle_name: receptionist?.middlename || "",
  mobile: receptionist?.mobile || "",
  email: receptionist?.Email || "",
  password: receptionist?.password || "",
  confirmPassword: receptionist?.password || "",
  gender: receptionist?.gender ? receptionist.gender.toLowerCase() : "",
  status: receptionist?.status ? receptionist.status.toLowerCase() : "active",
  aadhaar_card_number: receptionist?.aadhaar_card_number || "",
  address: receptionist?.address || "",
  date_of_birth: receptionist?.date_of_birth || "",
  city: receptionist?.city || "",
  country: receptionist?.country || "",
  state: receptionist?.state || "",
  pincode: receptionist?.pincode || "",
  postalCode: receptionist?.pincode || ""
});
    }
    console.log("rereceptionist", receptionist)
  }, []);
  

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "First Name is required";
    }
    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last Name is required";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    }

    

    if (!formData.aadhaar_card_number.trim()) {
      newErrors.aadhaar_card_number = "Aadhaar Number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (eventOrValue, fieldName) => {
    setFormData((prevData) => {
      let newData = { ...prevData };
  
      // Handle normal input fields
      if (eventOrValue && eventOrValue.target) {
        const { name, value } = eventOrValue.target;
        if (name) newData[name] = value;
      }
      // Handle DatePicker or other direct value components
      else if (fieldName) {
        newData[fieldName] = eventOrValue || "";
      }
      // Handle React-Select
      else if (eventOrValue && typeof eventOrValue === "object" && "value" in eventOrValue) {
        newData[fieldName] = eventOrValue.label;
      }
  
      return newData;
    });
  };
  const messageApi = useMessageApi();

  message.config({
          top: 100, // distance from top
          duration: 3,
          placement: 'topRight', // <-- key part for right side
        });
  
  const handleSubmit = async (e) => {
    console.log("formData", formData)
  e.preventDefault();

  if (validateForm()) {
    setIsClicked(true);



    try {
      const result = await updatePharmacist(id, formData);
      console.log("result", result)
      if (result.success) {
        messageApi.open({
          type: 'success',
          content: 'Pharmacist updated successfully',
        });
        console.log("payload", formData)
        console.log("id", id)
        console.log("Pharmacist updated successfully:", result);
        navigate("/pharmacistlist");
      } else {
        console.error("Update failed:", result.error);
        // Display error messages...
      }
    } catch (err) {
      console.error("Failed to update pharmacist:", err);
      messageApi.open({
        type: 'error',
        content: 'Failed to update pharmacist. Please try again.',
      });
    }
  }
};

  const handleCancel = () => {
    navigate('/pharmacistlist');
  };

  useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
    }, []);
  return (
    <div>
      <Sidebar activeClassName="Reception" />
      <>
        <div className="page-wrapper-doctor">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                     <Link to="/pharmacistlist">Receptionists </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Edit Receptionist</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Receptionist Details</h4>
                          </div>
                        </div>
                        {/* <div className="col-12 col-md-13 col-xl-12">
                          <div className="form-group local-forms">
                            <label>
                              Select Hospital <span className="login-danger">*</span>
                            </label>
                            <Select
                              menuPosition={'fixed'}
                              name="hospital"
                              defaultValue={hospital.find(opt => opt.label === formData.hospital)}
                              onChange={(selectedOption) => handleChange(selectedOption, "hospital")}
                              options={hospital}
                              menuPortalTarget={document.body}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
                                  transition: '250ms',
                                  width: '35px',
                                  height: '35px',
                                }),
                              }}
                            />
                            {errors.hospital && <p style={{ color: "red" }}>{errors.hospital}</p>}
                          </div>
                        </div> */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              First Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="name"
                              type="text"
                              placeholder=""
                              value={formData.name}
                              onChange={handleChange}
                            />
                            {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Middle Name 
                            </label>
                            <input
                              className="form-control"
                              name="middle_name"
                              type="text"
                              placeholder=""
                              value={formData.middle_name}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Last Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="last_name"
                              type="text"
                              placeholder=""
                              value={formData.last_name}
                              onChange={handleChange}
                            />
                            {errors.last_name && <p style={{ color: "red" }}>{errors.last_name}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Mobile <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="mobile"
                              type="text"
                              placeholder=""
                              value={formData.mobile}
                              onChange={handleChange}
                            />
                            {errors.mobile && <p style={{ color: "red" }}>{errors.mobile}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Email <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="email"
                              type="email"
                              placeholder=""
                              value={formData.email}
                              onChange={handleChange}
                            />
                            {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Password <span className="login-danger"></span>
                            </label>
                            <input
                              className="form-control"
                              name="password"
                              type="password"
                              placeholder="leave blank to keep current password"
                              value={formData.password}
                              onChange={handleChange}
                            />
                            {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Confirm Password{" "}<span className="login-danger"></span>
                            </label>
                            <input
                              className="form-control"
                              name="confirmPassword"
                              type="password"
                            placeholder="enter confirm password "
                              value={formData.confirmPassword}
                              onChange={handleChange}
                            />
                            {errors.confirmPassword && (<p style={{ color: "red" }}>{errors.confirmPassword}</p>)}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Aadhaar Card Number <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="aadhaar_card_number"
                              type="text"
                              placeholder=""
                              value={formData.aadhaar_card_number}
                              onChange={handleChange}
                            />
                            {errors.aadhar_card_number && <p style={{ color: "red" }}>{errors.aadhar_card_number}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-3 col-xl-3">
                          <div className="form-group local-forms cal-icon">
                            <label>
                              Date Of Birth{" "}
                            </label>
                            <DatePicker
                                                        className="form-control datetimepicker"
                                                        value={formData.date_of_birth ? dayjs(formData.date_of_birth) : null}
                                                        onChange={onChange}
                                                        format="YYYY-MM-DD"
                                                        style={{
                                                          borderColor: isClicked
                                                            ? "#2E37A4"
                                                            : "2px solid rgba(46, 55, 164, 0.1)",
                                                        }}
                                                      />
                          </div>
                        </div>
                        <div className="col-12 col-md-3 col-xl-3">
                          <div className="form-group select-gender">
                            <label className="gen-label">
                              Gender 
                            </label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  onChange={handleChange}
                                  value="male"
                                  className="form-check-input"
                                  checked={formData.gender === "male"}
                                />
                                Male
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  onChange={handleChange}
                                  value="female"
                                  name="gender"
                                  className="form-check-input"
                                  checked={formData.gender === "female"}
                                />
                                Female
                              </label>
                            </div>
                          </div>
                        </div>
                       <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group select-gender">
                            <label className="gen-label">Status<span className="login-danger">*</span></label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="status"
                                  onChange={handleChange}
                                  value="Active"
                                checked={formData.status === "Active"}
                                  className="form-check-input"
                                />
                                Active
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  onChange={handleChange}
                                  value="Deactivate"
                                checked={formData.status === "Deactivate"}
                                  name="status"
                                  className="form-check-input"
                                />
                                Deactive
                              </label>
                            </div>
                            {errors.status && (
                              <p style={{ color: "red" }}>{errors.status}</p>
                            )}
                          </div>
                          
                        </div>
                       
                        <div className="col-12 col-sm-12">
                          <div className="form-group local-forms">
                            <label>
                              Address 
                            </label>
                            <textarea
                              className="form-control"
                              name="address"
                              onChange={handleChange}
                              rows={3}
                              cols={30}
                              value={formData.address}
                            />
                          </div>
                        </div>
                         {/* City Select */}
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>City</label>
                            <input
                              className="form-control"
                              name="city"
                              type="text"
                              value={formData.city}
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.city && (
                              <p style={{ color: "red" }}>{errors.city}</p>
                            )}
                          </div>
                        </div>
                        {/* State Select */}
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>
                              State 
                            </label>
                            <Select
                              menuPosition={"fixed"}
                              name="state"
                              value={
                                statevalue?.find(
                                  (option) => option.value === formData.state
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                handleChange(selectedOption?.label, "state")
                              }
                              options={statevalue}
                              placeholder="Select State"
                              menuPortalTarget={document.body}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                            {errors.state && (
                              <p style={{ color: "red" }}>{errors.state}</p>
                            )}
                          </div>
                        </div>

                        {/* Country Select */}
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>
                              Country 
                            </label>
                            <Select
                              menuPosition={"fixed"}
                              name="country"
                              value={
                                country?.find(
                                  (option) => option.value === formData.country
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                handleChange(selectedOption?.label, "country")
                              }
                              options={country}
                              placeholder="Select Country"
                              menuPortalTarget={document.body}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                            {errors.country && (
                              <p style={{ color: "red" }}>{errors.country}</p>
                            )}
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Postal Code{" "}
                            </label>
                            <input
                              name="postalCode"
                              onChange={handleChange}
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={formData.pincode}
                            />
                          </div>
                        </div>
                      
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              type="submit"
                              onClick={handleSubmit}
                              className="btn btn-primary submit-form me-2"
                            >
                              Update
                            </button>
                            <button
                            type="button"
                              className="btn btn-primary cancel-form"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};
export default EditPharmaciest